import { createContext, useContext, useState, ReactNode } from 'react';
import { WorkflowDnDContextType } from './index.functions';

const DnDContext = createContext<WorkflowDnDContextType | undefined>(undefined);

interface DnDProviderProps {
    children: ReactNode;
}

export const DnDProvider = ({ children }: DnDProviderProps) => {
    const [type, setType] = useState<any | null>(null);
    const [nodeRole, setNodeRole] = useState<any | null>(null);

    return <DnDContext.Provider value={[type, setType, nodeRole, setNodeRole]}>{children}</DnDContext.Provider>;
};

export default DnDContext;

export const useDnD = (): WorkflowDnDContextType => {
    const context = useContext(DnDContext);
    if (context === undefined) {
        throw new Error('useDnD must be used within a DnDProvider');
    }
    return context;
};
